import React__default from 'react';
import PropTypes from 'prop-types';
import { verticalSpacingSizes } from '../../tools/constants.js';

var propTypes = {
  fallbackSrc: PropTypes.string.isRequired,
  alt: PropTypes.string,
  marginBottom: PropTypes.oneOf(verticalSpacingSizes),
  marginTop: PropTypes.oneOf(verticalSpacingSizes),
  sources: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired,
    srcSet: PropTypes.string.isRequired
  }))
};
function Picture(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    fallbackSrc = _ref.fallbackSrc,
    marginBottom = _ref.marginBottom,
    marginTop = _ref.marginTop,
    sources = _ref.sources;
  return /*#__PURE__*/React__default.createElement("picture", {
    className: "picture",
    "data-margin-bottom": marginBottom || null,
    "data-margin-top": marginTop || null,
    "data-testid": "picture"
  }, sources && sources.map(function (_ref2) {
    var key = _ref2.key,
      media = _ref2.media,
      srcSet = _ref2.srcSet;
    return /*#__PURE__*/React__default.createElement("source", {
      "data-testid": key,
      key: key,
      media: media,
      srcSet: srcSet
    });
  }), /*#__PURE__*/React__default.createElement("img", {
    alt: alt,
    src: fallbackSrc
  }));
}
Picture.propTypes = propTypes;

export { Picture as default };
//# sourceMappingURL=Picture.js.map
